/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Information about a participant with who offers an available slot
 */
export type AppointmentParticipantResponse = {
    /**
     * The user identifier for the participant.
     */
    userId: string;
    /**
     * The participant's role in the appointment.
     */
    role: AppointmentParticipantResponse.role;
    /**
     * The human-readable name of the participant.
     */
    displayName?: string;
    /**
     * The human-readable role of the participant.
     */
    displayRole?: string;
};

export namespace AppointmentParticipantResponse {

    /**
     * The participant's role in the appointment.
     */
    export enum role {
        STAFF = 'STAFF',
        MEMBER = 'MEMBER',
    }


}

